<div class="footer-container" fxLayout="row" fxLayoutAlign="center">
  <div fxLayout="column">
    <p>&copy; {{ copyrightYear }} HANDS LAB INC.</p>
  <div>
</div>

